var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle4, _path, _path2, _path3, _ellipse, _circle5, _path4, _circle6, _path5, _path6, _path7, _circle7, _path8, _path9, _path0, _path1, _path10, _path11, _circle8, _path12, _path13, _path14, _path15, _path16, _path17, _circle9, _path18, _path19, _path20, _path21, _path22, _path23, _circle0, _path24, _path25, _path26, _circle1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenrecorder3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "screenrecorder-3_svg__Group_41140",
    "data-name": "Group 41140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1138.772,
    height: 729.654,
    viewBox: "0 0 1138.772 729.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-3_svg__linear-gradient",
    x1: 0.208,
    x2: -0.055,
    y2: 1.352,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-3_svg__linear-gradient-2",
    x1: 0.677,
    y1: 0.226,
    x2: -0.055,
    y2: 1.352,
    xlinkHref: "#screenrecorder-3_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-3_svg__linear-gradient-3",
    y1: 0.779,
    x2: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11ebd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-3_svg__linear-gradient-6",
    x1: 1,
    y1: 0.5,
    x2: 0.5,
    y2: 0.5,
    xlinkHref: "#screenrecorder-3_svg__linear-gradient-3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13207",
    "data-name": "Rectangle 13207",
    width: 1138.286,
    height: 729.009,
    transform: "translate(0.486 0.645)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13208",
    "data-name": "Rectangle 13208",
    width: 1073.187,
    height: 594.445,
    transform: "translate(33.035 92.081)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13209",
    "data-name": "Rectangle 13209",
    width: 1138.286,
    height: 48.359,
    fill: "url(#screenrecorder-3_svg__linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_356",
    "data-name": "Ellipse 356",
    cx: 8.963,
    cy: 8.963,
    r: 8.963,
    transform: "translate(26.973 15.761)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 8.963,
    cy: 8.963,
    r: 8.963,
    transform: "translate(60.994 15.761)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 8.963,
    cy: 8.963,
    r: 8.963,
    transform: "translate(95.015 15.761)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13210",
    "data-name": "Rectangle 13210",
    width: 209.9,
    height: 227.722,
    transform: "translate(165.078 140.974)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13211",
    "data-name": "Rectangle 13211",
    width: 209.9,
    height: 227.722,
    transform: "translate(464.676 140.974)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13212",
    "data-name": "Rectangle 13212",
    width: 209.9,
    height: 227.722,
    transform: "translate(764.274 140.974)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13213",
    "data-name": "Rectangle 13213",
    width: 209.9,
    height: 227.722,
    transform: "translate(165.078 409.915)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13214",
    "data-name": "Rectangle 13214",
    width: 209.9,
    height: 227.722,
    transform: "translate(464.676 409.915)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-3_svg__Rectangle_13215",
    "data-name": "Rectangle 13215",
    width: 209.9,
    height: 227.722,
    transform: "translate(764.274 409.915)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 35.481,
    cy: 35.481,
    r: 35.481,
    transform: "translate(211.13 207.709)",
    fill: "#ffb9b9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21065",
    "data-name": "Path 21065",
    d: "M358.421,385.335s4.435,21.067,4.435,23.284,21.067,12.2,21.067,12.2l18.849-3.326,6.653-19.958s-11.088-16.632-11.088-23.285Z",
    transform: "translate(-125.67 -114.98)",
    fill: "#ffb9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21066",
    "data-name": "Path 21066",
    d: "M348.642,347.735s11.265-24.408,32.857-18.775,33.8,14.081,34.734,22.53-.469,21.122-.469,21.122S413.417,355.245,398.4,359s-38.489.939-38.489.939l-3.755,33.8s-4.224-6.1-8.918-2.347S333.622,355.246,348.642,347.735Z",
    transform: "translate(-132.802 -133.132)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21067",
    "data-name": "Path 21067",
    d: "M501.221,470.246l-8.863-39.923c-4.445-13.308-15.523-24.386-15.523-24.386l-54.68-19.23h-.014a22.964,22.964,0,0,1-16.262,21.46c-16.638,5.532-28.093-13.113-28.093-13.113l-46.222,35.269s-14.409,12.207-13.294,35.492l-1.533,12.959H505.485Z",
    transform: "translate(-142.072 -110.077)",
    fill: "url(#screenrecorder-3_svg__linear-gradient-2)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-3_svg__Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 48.159,
    cy: 51.123,
    rx: 48.159,
    ry: 51.123,
    transform: "translate(497.248 194.107)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 25.335,
    cy: 25.335,
    r: 25.335,
    transform: "translate(562.802 271.922)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21068",
    "data-name": "Path 21068",
    d: "M419.111,188.971l13.572,35.287L398.3,238.736l-3.02-6.843-10.554-23.92Z",
    transform: "translate(151.381 74.356)",
    fill: "#9f616a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_362",
    "data-name": "Ellipse 362",
    cx: 30.312,
    cy: 30.312,
    r: 30.312,
    transform: "translate(513.036 225.776)",
    fill: "#9f616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21069",
    "data-name": "Path 21069",
    d: "M565.946,381.637C585,368.924,590.693,365.885,612.531,370.8l1.31-31.859-56.432,11.838Z",
    transform: "translate(-47.373 -128.874)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21070",
    "data-name": "Path 21070",
    d: "M690.054,430.558l-.836.1a.537.537,0,0,0-.07-.084c-3.316-3.316-19.146-9.35-30.949-13.531h-.014c-7.5-2.662-13.363-4.571-13.363-4.571L630.552,397.8c-3.6,4.041-11.19,7.163-18.408,9.364a144.55,144.55,0,0,1-16.833,4.013H595.3l-2.954,9.434s-33.485,25.347-36.189,28.051h-.014v.028a1.473,1.473,0,0,0-.251,1.059v.07A122.869,122.869,0,0,0,553.3,474.41H699.112v-8.556C699.112,454.094,690.054,430.558,690.054,430.558Z",
    transform: "translate(-48.991 -105.714)",
    fill: "url(#screenrecorder-3_svg__linear-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21071",
    "data-name": "Path 21071",
    d: "M872,498.607H799.9l-3.971-39.171-.237-2.383-.488-4.724-1.993-19.746-2.494,21.209-5.267,44.814h-13.1l.488-13.949.488-14.144.209-5.7,2.689-77.533a55.36,55.36,0,0,1,11.05-34.126,43.117,43.117,0,0,1,34.823-16.847,44.368,44.368,0,0,1,35.422,17.46A56.1,56.1,0,0,1,869.1,388.41l1.24,46.932Z",
    transform: "translate(37.201 -129.91)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_363",
    "data-name": "Ellipse 363",
    cx: 31.713,
    cy: 31.713,
    r: 31.713,
    transform: "translate(827.584 221.691)",
    fill: "#fbbebe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21072",
    "data-name": "Path 21072",
    d: "M799.867,386.935s9.061,30.58,0,39.641-11.326,12.459-11.326,12.459l26.05,35.111,45.3-55.5s-31.713-9.061-23.785-33.978Z",
    transform: "translate(43.572 -110.879)",
    fill: "#fbbebe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21073",
    "data-name": "Path 21073",
    d: "M683.28,268.038H656.525l-.446-4.585-.4-4.236,12.318-1.547,14.854-1.853.167,4.752Z",
    transform: "translate(257.993 100.658)",
    fill: "#fbbebe"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21074",
    "data-name": "Path 21074",
    d: "M909.732,462.948s-4.531-28.315-7.928-39.641-6.8-11.326-6.8-11.326h0v0c-4-4-13.614-4.71-20.846-4.6-5.072.056-8.974.5-8.974.5l-40.4,42.613-20.345-27.047v-.014a29.611,29.611,0,0,0-5.421.934,35.915,35.915,0,0,0-4.487,1.463,61.563,61.563,0,0,0-17.182,11.022h-.014c-2.926,2.634-4.654,4.571-4.654,4.571a132.636,132.636,0,0,0-10.061,29.221H892.081l.293-5.825v-.011Z",
    transform: "translate(33.376 -101.947)",
    fill: "url(#screenrecorder-3_svg__linear-gradient)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21075",
    "data-name": "Path 21075",
    d: "M791.187,374.378c20.482-11.043,28.9-10.575,54.365,0l6.795-16.557a11.772,11.772,0,0,0-11.758-11.758H795.016a11.772,11.772,0,0,0-11.759,11.758Z",
    transform: "translate(41.494 -126.07)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21076",
    "data-name": "Path 21076",
    d: "M391.958,521.919A8.354,8.354,0,0,0,387.112,523a12.639,12.639,0,0,0-3.277,4.326,51.746,51.746,0,0,1-14.1,15.923c-4.189,3.068-9.514,6.895-8.8,12.552a16.965,16.965,0,0,0,2.042,5.3c3.864,7.8,14.408,13.828,13.371,22.728,3.839-6.427-1.3-9.6,2.543-16.032,1.828-3.061,5-6.516,7.764-4.593.924.644,1.531,1.8,2.493,2.363,2.3,1.347,4.739-1.229,6.772-3.053,7.009-6.292,16.976-4.643,25.7-2.683,4.118.926,8.64,2.14,11.074,6.075,3.2,5.174-3.041,10.762-4.617,16.612a3.188,3.188,0,0,0,3.421,3.967c2.617-.258,5.717-.47,5.872-1.618,3.293.117,7.327-.256,8.738-3.684a14.418,14.418,0,0,0,.676-4.193c.518-5.759,2.962-11.013,4.581-16.495s2.323-11.905-.409-16.765a19.4,19.4,0,0,0-3.58-4.351C431.874,524.371,411.484,521.9,391.958,521.919Z",
    transform: "translate(-124.704 -56.886)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21077",
    "data-name": "Path 21077",
    d: "M377.955,575.919s3.373,28.105-8.994,30.353S380.2,646.744,380.2,646.744l56.21,6.745-13.491-44.968s-8.994-3.373-3.373-25.857S377.955,575.919,377.955,575.919Z",
    transform: "translate(-122.933 -37.734)",
    fill: "#9f616a"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_364",
    "data-name": "Ellipse 364",
    cx: 33.726,
    cy: 33.726,
    r: 33.726,
    transform: "translate(246.59 489.282)",
    fill: "#9f616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21078",
    "data-name": "Path 21078",
    d: "M350.9,664.073c5.964-23.452,14.2-55.042,14.2-55.042s3.2.655,8.249,1.393a195.238,195.238,0,0,0,22.24,2.021c9.531.265,19.564-.362,27.326-3.052a25.588,25.588,0,0,0,8.068-4.306,15.554,15.554,0,0,0,2.7-2.8c13.489-17.99,19.1,50.583,19.1,50.583l1.045,11.2Z",
    transform: "translate(-128.63 -26.436)",
    fill: "url(#screenrecorder-3_svg__linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21079",
    "data-name": "Path 21079",
    d: "M428.606,698.1q-.669,0-1.338.042l.641-1.2C428.132,697.323,428.355,697.714,428.606,698.1Z",
    transform: "translate(-98.581 11.995)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21080",
    "data-name": "Path 21080",
    d: "M391.5,528.249a7.654,7.654,0,0,0-3.944.765,9.193,9.193,0,0,0-2.668,3.057,38.841,38.841,0,0,1-11.475,11.254c-3.41,2.169-7.745,4.873-7.161,8.872a11.1,11.1,0,0,0,1.662,3.745A29.458,29.458,0,0,1,371.5,574.3l9.375-13.627c1.488-2.163,4.074-4.605,6.321-3.247.752.455,1.246,1.271,2.03,1.67,1.869.952,3.858-.868,5.512-2.158,5.706-4.447,13.819-3.282,20.919-1.9,3.352.654,7.034,1.512,9.015,4.294,3.293,4.622-.146,11.3,1.776,16.641a4.906,4.906,0,0,0,2.03-3.24c2.68.083,5.965-.181,7.113-2.6a8.972,8.972,0,0,0,.551-2.963c.421-4.071,2.411-7.784,3.729-11.658s1.891-8.415-.333-11.849a14.335,14.335,0,0,0-2.914-3.076C424,529.982,407.4,528.234,391.5,528.249Z",
    transform: "translate(-122.608 -54.392)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21081",
    "data-name": "Path 21081",
    d: "M407.672,614.25c-7.692-8.793-12.263-21.613-12.472-22.184v-.014s-12.263-7.023-15.635-.279-34.851,23.605-38.223,23.605a.439.439,0,0,1-.084.028c-1.338.446-18.087,6.535-22.393,29.207A169.684,169.684,0,0,0,317,668.178h91.677c.948-9.936,1.658-19.23,1.937-27.256.4-11.19.014-19.885-1.686-24.372A7.1,7.1,0,0,0,407.672,614.25Z",
    transform: "translate(-141.969 -30.54)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21082",
    "data-name": "Path 21082",
    d: "M452.961,619.05c-.056-.265-.1-.488-.139-.7a5.186,5.186,0,0,0-.753-1.672.107.107,0,0,1-.014-.042c-6.494-10.061-48.256-23.912-48.256-23.912l-1.561,5.393s.2,5.323.474,13.851c.279,7.985.613,18.77.934,30.615.223,7.734.418,15.928.6,24.065h62.47A364.817,364.817,0,0,0,452.961,619.05Z",
    transform: "translate(-108.429 -29.013)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21083",
    "data-name": "Path 21083",
    d: "M858.078,652.9l4.78-23.355,4.445-1.881.028.014c.4.153,5.24,2.2,5.24,9.963,0,1.561-.237,7.176-.627,15.259Z",
    transform: "translate(70.934 -15.265)",
    fill: "#575a89"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_365",
    "data-name": "Ellipse 365",
    cx: 38.816,
    cy: 38.816,
    r: 38.816,
    transform: "translate(839.992 478.43)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21084",
    "data-name": "Path 21084",
    d: "M663.139,387.44,659.9,453.75l-50.137-29.111,6.469-37.2Z",
    transform: "translate(239.929 152.449)",
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21085",
    "data-name": "Path 21085",
    d: "M678.307,450.245l-3.289,28.2H648.7L620.129,423.56l-8.054-15.454-3.86-2.522,4.473-1.017,3.526,2.55,39.449,28.58,6.326-18.993.167-.488,1.589-4.78Z",
    transform: "translate(239.319 159.188)",
    fill: "url(#screenrecorder-3_svg__linear-gradient-6)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21086",
    "data-name": "Path 21086",
    d: "M810.291,537.766s4.852-24.26,32.347-19.408l-3.235,1.617s25.877-3.235,22.643,11.321c0,0,21.026,12.939,16.173,27.495a164.556,164.556,0,0,0-6.469,25.877l-4.852-4.852s-4.852-32.347-33.964-29.112c-21.834,2.426-30.73,12.737-33,20.166a65.62,65.62,0,0,1-4,10.165l-1.817.4S784.413,545.853,810.291,537.766Z",
    transform: "translate(45.065 -58.528)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21087",
    "data-name": "Path 21087",
    d: "M908.37,643.1l-.028-.014-20.609-19.146V611.006l-15.914-12.541-.237,7.622-1.644,51.823-26.462-36.4L825.64,596.987l-3.205-4.39.78-4.111-9.88,11.19L777.579,626.5l-3.066,2.3a97.511,97.511,0,0,0-9.7,11.315c-.961,1.435-5.337,12.862-11.036,28.2h159.2c.39-8.082.627-13.7.627-15.259C913.61,645.3,908.775,643.251,908.37,643.1Z",
    transform: "translate(29.894 -30.682)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21088",
    "data-name": "Path 21088",
    d: "M611.328,528.783h0c-26.3,0-47.626,23.664-47.626,52.854v37.087h11.407l6.6-13.741-1.651,13.741h73.315l6-12.492-1.5,12.492h8.255V589.6C666.134,556.013,641.6,528.783,611.328,528.783Z",
    transform: "translate(-44.897 -54.174)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21089",
    "data-name": "Path 21089",
    d: "M579.132,655.138H548.155l-.293-25.264c-.014-.265-.014-.516-.014-.78l6.2-6.981.112-.125,23.675,14.994Z",
    transform: "translate(-51.135 -17.5)",
    fill: "#d0cde1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_366",
    "data-name": "Ellipse 366",
    cx: 33.905,
    cy: 33.905,
    r: 33.905,
    transform: "translate(528.313 491.559)",
    fill: "#fbbebe"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21090",
    "data-name": "Path 21090",
    d: "M580.907,582.174s9.945,51.535,5.425,56.96,47.919-9.945,47.919-9.945-17.178-35.261-8.137-55.152Z",
    transform: "translate(-38.127 -36.368)",
    fill: "#fbbebe"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21091",
    "data-name": "Path 21091",
    d: "M685.982,608.367h-.014a7.784,7.784,0,0,0-3.888-3.79c-6.647-2.8-12.374-4.947-17.084-6.577a36.127,36.127,0,0,0-25.556.794c-.794.32-1.575.669-2.341,1.059,0,0-33.151,6.313-37.094,5.518-.293-.056-.6-.1-.892-.125a15.605,15.605,0,0,0-1.8-.153,39.719,39.719,0,0,0-22.017,5.463c-10.883,6.312-27.02,17.5-27.354,28.4l-.307.348.307,26.044H693.452c.293-24.957.46-43.713.46-44.982C693.911,616.421,685.982,608.367,685.982,608.367Z",
    transform: "translate(-51.218 -27.709)",
    fill: "url(#screenrecorder-3_svg__linear-gradient)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-3_svg__Path_21092",
    "data-name": "Path 21092",
    d: "M622.642,542.071a24.978,24.978,0,0,0-19.708-10.057H602c-18.028,0-32.643,16.313-32.643,36.437H575.4l.976-7.426,1.43,7.426h35.827l3-6.282-.75,6.282h7.049q4.934,24.5-14.177,49H620.76l6-12.565-1.5,12.565H648.15l4.5-28.9C652.652,566.912,640.078,548.56,622.642,542.071Z",
    transform: "translate(-42.672 -52.903)",
    fill: "#2f2e41"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-3_svg__Ellipse_367",
    "data-name": "Ellipse 367",
    cx: 17.838,
    cy: 17.838,
    r: 17.838,
    transform: "translate(568.713 456.535)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenrecorder3);
export default __webpack_public_path__ + "static/media/screenrecorder-3.59843f4e695e18b44a87c292e9100ede.svg";
export { ForwardRef as ReactComponent };